<template>
  <div class="section-main__warp fan-run-status">
    <div class="section-mian_left left">
      <div class="chartContent">
        <div class="search">
          蒸发器日时长统计
          <span>
            建筑
            <el-select clearable v-model="chartColdStorageCode" style="margin-right: 12px; width: 130px"
              @change="handleSearchCold('getChartDate')">
              <el-option v-for="item in coldStorageList" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>

            日期
            <el-date-picker v-model="chartDate" @change="handleSearchDate('getChartDate')" type="date"
              value-format="yyyy-MM-dd" style="width: 130px" placeholder="选择日期" :clearable="isClearable">
            </el-date-picker>
          </span>
        </div>
        <div id="barCharts" class="chart"></div>
      </div>
      <div class="chartContent">
        <div class="search">
          蒸发器月时长统计
          <span>
            建筑
            <el-select clearable v-model="chartColdStorageCode2" style="margin-right: 12px; width: 130px"
              @change="handleSearchCold('getChartDate2')">
              <el-option v-for="item in coldStorageList" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>

            日期
            <el-date-picker v-model="chartDate2" type="month" value-format="yyyy-MM"
              @change="handleSearchDate('getChartDate2')" style="width: 130px" placeholder="选择日期"
              :clearable="isClearable">
            </el-date-picker>
          </span>
        </div>
        <div id="barCharts2" class="chart"></div>
      </div>
      <div class="chartContent">
        <div class="search">
          蒸发器年时长统计
          <span>
            建筑
            <el-select clearable v-model="chartColdStorageCode3" style="margin-right: 12px; width: 130px"
              @change="handleSearchCold('getChartDate3')">
              <el-option v-for="item in coldStorageList" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>

            日期
            <el-date-picker v-model="chartDate3" type="year" value-format="yyyy"
              @change="handleSearchDate('getChartDate3')" style="width: 130px" placeholder="选择日期"
              :clearable="isClearable">
            </el-date-picker>
          </span>
        </div>
        <div id="barCharts3" class="chart"></div>
      </div>
    </div>

    <div class="section-mian_right right">
      <div class="right-top">
        <div class="search">
          蒸发器状态统计
          <span>
            建筑
            <el-select style="width: 130px" v-model="coldStorageCode" clearable
              @change="handleSearchCold('countWithRunStatus')">
              <el-option v-for="item in coldStorageList" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </span>
        </div>
        <div class="fanNumContent">
          <div class="fanNum" v-for="(item, index) in fanNumList" :key="index">
            <div class="fanNum-item">
              <div :class="['fanNum-bg', item.color]">
                <img class="img" src="~@/common/assets/images/风机2.png" alt="" />
              </div>
              <div>
                <div class="fanNum-num">
                  {{ item.value }}
                  <span>台</span>
                </div>
                <div class="fanNum-title">{{ item.label }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="right-middle">
        <div class="search">
          蒸发器运行明细
          <span>
            建筑
            <el-select clearable style="width: 130px" v-model="tableColdStorageCode"
              @change="handleSearchCold('getListData')">
              <el-option v-for="item in coldStorageList" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </span>
        </div>
        <ioc-table ref="crud" :data="tableList" :option="option" :page="page" @search-change="getList"
          @search-reset="getList" @size-change="sizeChange" @current-change="pageChange">
        </ioc-table>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@src/common/utils";
import eCharts from "echarts";
import tableOption from "../const/statusTable";
import { api } from "../api/api.js";
export default {
  components: {},
  data() {
    return {
      isClearable: false,
      chartDate: utils.Dates.dayjs(new Date().getTime()).format("YYYY-MM-DD"),
      chartDate2: utils.Dates.dayjs(new Date().getTime()).format("YYYY-MM"),
      chartDate3: utils.Dates.dayjs(new Date().getTime()).format("YYYY"),

      barCharts: null,
      barCharts2: null,
      barCharts3: null,

      chartColdStorageCode: "",
      chartColdStorageCode2: "",
      chartColdStorageCode3: "",

      option: tableOption(this),
      searchForm: {},
      tableList: [],
      coldStorageCode: "",
      tableColdStorageCode: "",
      page: {
        pageNumber: 1,
        total: 0,
        pageSize: 10,
      },
      coldStorageList: [],
      fanNumList: [
        {
          label: "蒸发器总数",
          value: "0",
          color: "bg1",
        },
        {
          label: "运行数量",
          value: "0",
        },
        {
          label: "停止数量",
          value: "0",
          color: "bg3",
        },
        {
          label: "故障数量",
          value: "0",
          color: "bg2",
        },
      ],
    };
  },
  created() {
    this.queryColdStorageList(); //查询冷库
    this.countWithRunStatus(); //查询数量
    this.getListData();
  },
  mounted() {
    this.getChartDate();
    this.getChartDate2();
    this.getChartDate3();

    // let nowTime = utils.Dates.dayjs(new Date().getTime()).format("YYYY-MM-DD");
    // this.$nextTick(() => {
    //   this.$refs.crud.searchForm.date = [nowTime, nowTime];
    //   this.$refs.crud.query();
    // });

    window.onresize = () => {
      this.barCharts && this.barCharts.resize();
      this.barCharts2 && this.barCharts2.resize();
      this.barCharts3 && this.barCharts3.resize();
    };
  },
  beforeDestroy() { },
  methods: {
    handleSearchCold(type) {
      this[type] && this[type]();
    },
    handleSearchDate(type) {
      this[type] && this[type]();
    },
    queryColdStorageList() {
      this.$fetch(api.queryColdStorageList, {
        pageNum: 1,
        pageSize: 1000,
      }).then((response) => {
        if (response.success) {
          let obj = response.returnObj;
          let coldStorageList = obj.list.map((el) => {
            return {
              label: el.storageName,
              value: el.storageCode,
            };
          });
          this.coldStorageList = coldStorageList.reverse();
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    getList(params) {
      this.page.pageNumber = 1;
      this.searchForm = Object.assign({}, params);
      this.getListData();
    },
    getListData() {
      let nowTime = utils.Dates.dayjs(new Date().getTime()).format("YYYY-MM-DD");
      let params = {
        ...this.searchForm,
        ...this.page,
        coldStorageCode: this.tableColdStorageCode,
      };
      params.startDate = params["date"] ? params["date"][0] : nowTime;
      params.endDate = params["date"] ? params["date"][1] : nowTime;
      delete params.date;
      delete params.total;
      this.$fetch(api.runTimeWithDevice, params).then((res) => {
        if (res.success) {
          this.page.total = res.returnObj.total;
          this.tableList = res.returnObj.list;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.page.pageNumber = 1;
      this.getListData();
    },
    pageChange(pageNo) {
      this.page.pageNumber = pageNo;
      this.getListData();
    },
    getChartDate() {
      let params = {
        queryTime: this.chartDate,
        coldStorageCode: this.chartColdStorageCode,
      };
      this.$fetch(api.runTimeWithHourOfDay, params).then((res) => {
        if (!res.success) {
          this.$message.error(res.msgContent);
        }
        let obj = res.returnObj;
        this.initChart({
          xData: obj.columns,
          list: obj.list.map((el) => {
            return {
              name: el.key,
              value: el.running,
            };
          }),
          list2: obj.list.map((el) => {
            return {
              name: el.key,
              value: el.fault,
            };
          }),
        });
      });
    },
    getChartDate2() {
      let params = {
        queryTime: this.chartDate2,
        coldStorageCode: this.chartColdStorageCode2,
      };
      this.$fetch(api.runTimeWithDayOfMonth, params).then((res) => {
        // loading.close();
        if (!res.success) {
          this.$message.error(res.msgContent);
        }
        let obj = res.returnObj;
        this.initChart2({
          xData: obj.columns,
          list: obj.list.map((el) => {
            return {
              name: el.key,
              value: el.running,
            };
          }),
          list2: obj.list.map((el) => {
            return {
              name: el.key,
              value: el.fault,
            };
          }),
        });
      });
    },
    getChartDate3() {
      let params = {
        queryTime: this.chartDate3,
        coldStorageCode: this.chartColdStorageCode3,
      };
      this.$fetch(api.runTimeWithMonthOfYear, params).then((res) => {
        // loading.close();
        if (!res.success) {
          this.$message.error(res.msgContent);
        }
        let obj = res.returnObj;
        this.initChart3({
          xData: obj.columns,
          list: obj.list.map((el) => {
            return {
              name: el.key,
              value: el.running,
            };
          }),
          list2: obj.list.map((el) => {
            return {
              name: el.key,
              value: el.fault,
            };
          }),
        });
      });
    },
    initChart(data) {
      // 柱状图
      let chartDom = document.getElementById("barCharts");
      let option = {
        legend: {
          top: 0,
          right: 0,
          icon: "circle",
          itemHeight: 10, // 修改icon图形大小
          itemGap: 24,
          textStyle: {
            fontSize: 14,
            color: "#333",
            padding: [0, 0, 0, 0], // 修改文字和图标距离
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
          textStyle: {
            fontSize: 12,
          },
          formatter: (params) => {
            let msg =
              this.chartDate +
              "【" +
              data.xData[params[0].dataIndex] +
              "时 】" +
              "</br>" +
              "运行：" +
              params[0].value +
              "<br/>" +
              "故障：" +
              params[1].value;
            return msg;
          },
        },
        grid: {
          top: 40,
          right: 0,
          bottom: 20,
          left: 60,
        },
        xAxis: [
          {
            data: data.xData,
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              fontSize: 12,
              color: "#182524",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "分钟/min",
            nameTextStyle: {
              color: "#182524",
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "#dcdfe6",
              },
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              fontSize: 12,
              color: "#182524",
              show: true,
            },
          },
        ],
        series: [
          {
            name: "运行",
            type: "bar",
            barWidth: 10,
            stack: "站点",
            barGap: "-100%",
            showBackground: false,
            itemStyle: {
              color: new eCharts.graphic.LinearGradient(
                0,
                0,
                0,
                1, // 表示从上到下
                [
                  { offset: 1, color: "#15b36c " },
                  { offset: 0, color: "#25e28d " },
                ]
              ),
            },
            label: {
              show: false,
            },
            data: data.list,
          },
          {
            name: "故障",
            type: "bar",
            stack: "站点",
            barWidth: 10,
            label: {
              show: false,
            },
            barGap: "-100%",
            itemStyle: {
              color: new eCharts.graphic.LinearGradient(
                0,
                0,
                0,
                1, // 表示从上到下
                [
                  { offset: 1, color: "rgba(255,0,0,1)" },
                  { offset: 0, color: "rgba(255,0,0,0.4)" },
                ]
              ),
            },
            data: data.list2,
          },
        ],
        animationDuration: 3000,
      };
      this.barCharts = eCharts.init(chartDom);
      this.barCharts.setOption(option);
    },
    initChart2(data) {
      let color = ["#25e28d", "#ff0000 "];
      // 折线图
      let chartDom2 = document.getElementById("barCharts2");
      let option2 = {
        color: color,
        legend: {
          icon: "rect",
          itemHeight: 10,
          itemWidth: 10,
          right: 0,
          top: 0,
          textStyle: {
            fontSize: 14,
            color: "#333",
            padding: [4, 0, 0, 0], // 修改文字和图标距离
          },
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: 50,
          left: 30,
          bottom: 0,
          right: 30,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLabel: {
              textStyle: {
                color: "#182524",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(230,247,255,0.2)",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#E4F5FD",
              },
            },
            data: data.xData,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "小时/h",
            axisLabel: {
              textStyle: {
                color: "#182524",
              },
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "运行",
            type: "line",
            smooth: true,
            symbol: "none",

            symbolSize: 10,
            lineStyle: {
              normal: {
                color: color[0],
                width: 2,
              },
            },
            areaStyle: {
              color: new eCharts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "rgba(27, 235, 242, 0)",
                },
                {
                  offset: 1,
                  color: color[0],
                },
              ]),
            },
            data: data.list,
          },
          {
            name: "故障",
            type: "line",
            smooth: true,
            symbol: "none",
            symbolSize: 10,
            lineStyle: {
              normal: {
                color: color[1],
                width: 2,
              },
            },
            areaStyle: {
              color: new eCharts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "rgba(27, 235, 242, 0)",
                },
                {
                  offset: 1,
                  color: color[1],
                },
              ]),
            },
            data: data.list2,
          },
        ],
        animationDuration: 3000,
      };
      this.barCharts2 = eCharts.init(chartDom2);
      this.barCharts2.setOption(option2);
    },
    initChart3(data) {
      // 折线图
      let color = ["#25e28d", "#ff0000 "];
      let chartDom3 = document.getElementById("barCharts3");
      let option3 = {
        color: color,
        legend: {
          icon: "rect",
          itemHeight: 10,
          itemWidth: 10,
          right: 0,
          top: 0,
          textStyle: {
            fontSize: 14,
            color: "#333",
            padding: [4, 0, 0, 0], // 修改文字和图标距离
          },
        },
        tooltip: {
          trigger: "axis",
        },
        grid: {
          top: 50,
          left: 30,
          bottom: 0,
          right: 30,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            axisLabel: {
              textStyle: {
                color: "#182524",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(230,247,255,0.2)",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#E4F5FD",
              },
            },
            data: data.xData,
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "小时/h",
            axisLabel: {
              textStyle: {
                color: "#182524",
              },
            },
            splitLine: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "运行",
            type: "line",
            smooth: true,
            symbol: "none",

            symbolSize: 10,
            lineStyle: {
              normal: {
                color: color[0],
                width: 2,
              },
            },
            areaStyle: {
              color: new eCharts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "rgba(27, 235, 242, 0)",
                },
                {
                  offset: 1,
                  color: color[0],
                },
              ]),
            },
            data: data.list,
          },
          {
            name: "故障",
            type: "line",
            smooth: true,
            symbol: "none",

            symbolSize: 10,
            lineStyle: {
              normal: {
                color: color[1],
                width: 2,
              },
            },
            areaStyle: {
              color: new eCharts.graphic.LinearGradient(0, 1, 0, 0, [
                {
                  offset: 0,
                  color: "rgba(27, 235, 242, 0)",
                },
                {
                  offset: 1,
                  color: color[1],
                },
              ]),
            },
            data: data.list2,
          },
        ],
        animationDuration: 3000,
      };
      this.barCharts3 = eCharts.init(chartDom3);
      this.barCharts3.setOption(option3);
    },
    countWithRunStatus() {
      this.$fetch(api.countWithRunStatus, {
        coldStorageCode: this.coldStorageCode,
      }).then((response) => {
        if (response.success) {
          let obj = response.returnObj;
          this.fanNumList[0].value = obj.total;
          this.fanNumList[1].value = obj.running;
          this.fanNumList[2].value = obj.stop;
          this.fanNumList[3].value = obj.fault;
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";
$themeColor: rgba(241, 246, 253, 1);

.search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-left: 6px solid #5572ff;
  margin: 12px;
  font-size: 16px;
  height: 24px;
  padding-left: 12px;
}

.fan-run-status {
  margin: 0;

  .left {
    padding-bottom: 12px;
    flex: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .chartContent {
      flex: 1;
      width: 100%;
    }

    .chart {
      flex: 1;
      width: 100%;
      height: calc(100% - 50px);
      padding: 12px;
    }
  }

  .right {
    padding-bottom: 12px;
    flex: 3;

    &-top {
      background: #fff;
    }

    &-middle {
      display: flex;
      flex-direction: column;
      margin-top: 8px;
      height: calc(100% - 200px);
      background: #fff;
    }

    .fanNumContent {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 12px 0 24px;
    }

    .fanNum {
      margin: 12px 0;
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 23%;
      height: 118px;
      // padding: 0px 18px;
      background: $themeColor;
      border-radius: 10px;

      &-bg {
        width: 60px;
        height: 60px;
        background: linear-gradient(270deg, #15b36c 0%, #25e28d 100%);
        border-radius: 30px 30px 30px 30px;
        opacity: 1;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .bg3 {
        background: gray !important;
      }

      .bg2 {
        background: #ff0000 !important;
      }

      .bg1 {
        background: linear-gradient(270deg, #5572ff 0%, #c877fa 100%) !important;
      }

      &-item {
        width: 100%;
        display: flex;
        flex-direction: row;
        height: 100%;
        align-items: center;
        justify-content: space-evenly;
      }

      &-num {
        height: 24px;
        font-size: 24px;
        font-family: Inter, Inter;
        font-weight: 500;
        color: #182524;
        line-height: 24px;
        -webkit-background-clip: text;

        span {
          color: #6b7373;
          font-size: 14px;
          margin-left: 4px;
        }
      }

      &-title {
        margin-top: 10px;
        height: 20px;
        font-size: 16px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        color: #6b7373;
        line-height: 20px;
        -webkit-background-clip: text;
      }
    }
  }
}
</style>
